var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterActivities({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41675 2.33338H2.33341C2.024 2.33338 1.72725 2.4563 1.50846 2.67509C1.28966 2.89389 1.16675 3.19063 1.16675 3.50005V11.6667C1.16675 11.9761 1.28966 12.2729 1.50846 12.4917C1.72725 12.7105 2.024 12.8334 2.33341 12.8334H10.5001C10.8095 12.8334 11.1062 12.7105 11.325 12.4917C11.5438 12.2729 11.6667 11.9761 11.6667 11.6667V7.58338M10.7917 1.45838C11.0238 1.22632 11.3386 1.09595 11.6667 1.09595C11.9949 1.09595 12.3097 1.22632 12.5417 1.45838C12.7738 1.69045 12.9042 2.0052 12.9042 2.33338C12.9042 2.66157 12.7738 2.97632 12.5417 3.20838L7.00008 8.75005L4.66675 9.33338L5.25008 7.00005L10.7917 1.45838Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterActivities);
export default __webpack_public_path__ + "static/media/help-center-activities.7a5dd632d3054a1687b553309f289d4c.svg";
export { ForwardRef as ReactComponent };